module.exports = __webpack_public_path__ + "img/TV_clean_box13.f86b170f.jpg";